import 'twin.macro';
import React from 'react';
import { Field, Form } from 'react-final-form';
import H2 from '@teetsh/app/src/components/Typography/Headings/H2';
import { Radios } from '@teetsh/app/src/components/Form/Radios';
import SimpleModal from '@teetsh/app/src/components/SimpleModal';
import { useNavigate } from 'react-router-dom';
import { reasonsToCancel } from './reasonsToCancel';
import subscriptionUrl from '@teetsh/app/src/containers/UserSettings/Souscription/urls';
import useCancelSubscription from '@teetsh/app/src/containers/UserSettings/Souscription/useCancelSubscription';
import { useUser } from '@teetsh/app/src/containers/App/context/useUser';
import { useTranslation } from 'react-i18next';
import { useTranslatedValidation } from 'utils/useTranslatedValidation';

export function ReasonLeave() {
  const user = useUser();
  const navigate = useNavigate();
  const { t } = useTranslation(['userSettings']);
  const { required } = useTranslatedValidation();
  const cancelSubscription = useCancelSubscription();
  const onClose = () => navigate('/settings/subscription');
  return (
    <Form<{ reasonValue: string }>
      initialValues={{}}
      onSubmit={async v => {
        const matchingReason = reasonsToCancel.find(
          r => r.value === v.reasonValue,
        );
        if (matchingReason?.value === 'otherTool2') {
          return navigate(subscriptionUrl.otherTool());
        }
        if (matchingReason?.hasDetails) {
          return navigate(
            `${subscriptionUrl.details()}?reason=${matchingReason.value}`,
          );
        }
        await cancelSubscription({
          cancelReason: matchingReason?.value as any,
        }).then(() =>
          navigate(
            `${subscriptionUrl.recap()}?previousPlan=${user.currentPlan}`,
          ),
        );
      }}
    >
      {({ handleSubmit, submitting, valid }) => (
        <SimpleModal
          isOpen
          closeModalFct={() => onClose()}
          validateTitle={t(
            'userSettings:subscription.cancel.featureWarningModal.continueCancel',
          )}
          disabled={!valid}
          isLoading={submitting}
          validateAction={() => handleSubmit()}
        >
          <div tw="p-8">
            <H2 tw="mb-8">
              {t('userSettings:subscription.cancel.reasons.why')}
            </H2>
            <Field
              name="reasonValue"
              validate={required}
              render={({ input: { value, onChange } }) => (
                <Radios
                  value={value}
                  onChange={v => onChange(v)}
                  options={reasonsToCancel.map(r => ({
                    label: t(
                      `userSettings:subscription.cancel.reasons.${r.value}`,
                    ),
                    value: r.value,
                  }))}
                />
              )}
            />
          </div>
        </SimpleModal>
      )}
    </Form>
  );
}
